const getRandom = () => (
  `i${Math.random()
    .toString(36)
    .slice(2)}`
);

export default {
  getRandom,
};
